import { CanActivateFn } from "@angular/router";

export const onlineGuard: CanActivateFn = () => {
  return navigator.onLine;
};
